import React, { useState, useEffect, useContext } from 'react';
import { sendSignInLinkToEmail } from 'firebase/auth';
import { auth } from '../firebaseconfig';
import Modal from './Modal';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { Navbar } from './NavBar';

export function LoginFans() {

    const navigate = useNavigate()

    const { user, signOut } = useContext(AuthContext)

    const [email, setEmail] = useState('')

    const [checkEmailAlert, setCheckEmailAlert] = useState(false)

    const actionCodeSettings = {
        url: "https://m-faktor.web.app/finish-signup",
        handleCodeInApp: true,
        //linkDomain: 'custom-domain.com'
    };

    useEffect(() => {

        // If user is logged in redirect to the vote page
        if (user) {
            navigate("/vote-fans")
            return
        }

        // Set default back navigation to home page
        const handlePopState = (event) => {
            event.preventDefault();
            navigate("/", { replace: true });
        };

        window.addEventListener("popstate", handlePopState);

        return () => {window.removeEventListener("popstate", handlePopState)}
        
    }, [navigate, user]);

    async function forwardUser() {

        // Check if there is an email input
        if (email === null || email === "") {
            alert("Kérjük adja meg az email címét!");
            return;
        }

        // Check if the email is valid
        if (email.includes("@tanulo.szmg.hu") || email.includes("@szmg.hu")) {

            // Send the email link to the user
            sendSignInLinkToEmail(auth, email, actionCodeSettings)
            .then(() => {
                setCheckEmailAlert(true)
                window.localStorage.setItem('emailForSignIn', email);
                setEmail(null)
            })
            .catch((error) => {
                alert("Hiba történt a link elküldése közben. Kérem próbálja újra később!")
                console.error('Error sending email link:', error.code, error.message);
            });

        }

    }

    return (

        <>

            <div className='background-container'>

                <Navbar text1="Zsűri Bejelentkezés" onClick1={() => navigate("/vote-judge", {replace: true})} text2="Kijelentkezés" onClick2={() => {signOut();setEmail('')}} second/>

                <div className="container">  
                    <div className="login-container">
                        <h2>Közönség Bejelentkezés</h2>
                        <div className="input-group">
                            <label htmlFor="email">Email</label>
                            <input
                            type="email"
                            id="email"
                            placeholder="email@tanulo.szmg.hu"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            />
                        </div>
                        <button className="login-button" onClick={forwardUser}>Bejelentkezés</button>
                    </div>

                </div>  

                {checkEmailAlert && <Modal show={checkEmailAlert} onClose={() => setCheckEmailAlert(false)}>
                    <p style={{ color: 'black' }}>Kérem ellenőrizze az e-mail fiókját, és aktiválja a regisztrációját az üzenetben található linkkel.</p>
                </Modal>}

            </div>
        </>
    )
}

